import { VariableType } from 'json-to-graphql-query';
import { EmployeeVariables, EmployeeArgs } from './queryVariables/employee';
import { EntityResource } from './entity.resource';
import { ProfileVariables, ProfileArgs } from './queryVariables/profile';
/**
 * Resource pracowników
 *
 * @export
 * @class EmployeeResource
 * @extends {Resource}
 */
export class EmployeeResource extends EntityResource {
    constructor() {
        super({
            entityName: 'profile',
            addMutationName: 'partnerEmployeeAdd'
        });
        this.getVariables = { id: 'String!' };
        this.getFields = {
            id: true,
            firstName: true,
            lastName: true,
            email: true,
            mainImage: true,
            userId: true,
            user: {
                login: true,
                state: true
            }
        };
        this.listFields = {
            id: true,
            firstName: true,
            lastName: true,
            email: true,
            userId: true,
            state: true
        };
        this.addVariables = { login: 'String!', ...EmployeeVariables };
        this.addArgs = { login: new VariableType('login'), ...EmployeeArgs };
        this.updateVariables = { id: 'Int!', ...ProfileVariables };
        this.updateArgs = { id: new VariableType('id'), ...ProfileArgs };
    }
    /**
     *  Pobieranie listy pracowników
     *
     * @param {number} id
     * @returns {Promise<Employee[]>}
     * @memberof EmployeeResource
     */
    async employeeList(id) {
        const query = this.prepareOptions({
            query: {
                __variables: { id: 'Int!' },
                partner: {
                    __args: { id: new VariableType('id') },
                    id: true,
                    employees: {
                        ...this.listFields
                    }
                }
            }
        });
        const data = await this.query({ query, variables: { id } });
        return data.partner.employees;
    }
}
export const employeeResource = new EmployeeResource();
//# sourceMappingURL=employee.resource.js.map